import axios from 'axios';
import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Pagination,
  Box,
  Grid,
  Tooltip
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import SyncLoader from "react-spinners/SyncLoader";

function DocumentTable() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  // Pagination
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const [rowsPerPage] = useState(12);

  // Fetch documents
  useEffect(() => {
    const fetchDocuments = async (instance) => {
      try {
        const token_response = await instance.acquireTokenSilent({...{scopes: ["User.Read"]}, account: accounts[0]})
        const headers =  {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + token_response.accessToken,
        }
        const response = await axios.get("https://openai-intake-app.azurewebsites.net/v1/document/list", {
          headers: headers,
        });
        setDocuments(response.data.documents);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching documents:", err);
        setError(err);
        setLoading(false);
      }
    };
    fetchDocuments(instance);
  }, [instance]);  

  const handleChangePage = (event, newPage) => {
    if (newPage === 1) {
        setSearchParams({});
      } else {
        setSearchParams({ page: newPage });
      }
  };

  const handleRowClick = (id) => {
    navigate(`/document/${id}`);
  };

  const paginatedDocuments = documents.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  if (loading) {
    return <div>
          <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}

    >
      <Grid container item xs={3} width="60%" justifyContent="center" alignItems="center" >
      <SyncLoader
          color="#236ECA"
          loading={loading}
          size={20}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Grid>
    </Grid>
    </div>;
  }

  if (error) {
    return <div>Error loading documents: {error.message}</div>;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <TableContainer component={Paper} sx={{ flexGrow: 1 }}>
        <Table>
          <TableBody>
            {paginatedDocuments.map((document) => (
              <Tooltip
                key={document.id}
                title={document.state === 'failed' ? 'This document failed because of a content warning flag from OpenAI. We\'re working on fixing this!' : ''}
                disableHoverListener={document.state !== 'failed'}
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '14px', // Increase the font size
                      padding: '10px',  // Increase the padding
                    },
                  },
                }}
              >
              <TableRow
                key={document.id}
                hover={document.state === 'complete'}
                onClick={document.state === 'complete' ? () => handleRowClick(document.id) : null}
                style={{
                  cursor: document.state === 'complete' ? "pointer" : "default",
                  backgroundColor: document.state === 'complete' ? "" : "#FFADB0",
                }}
              >
                <TableCell>{document.title}</TableCell>
              </TableRow>
              </Tooltip>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Pagination
          count={Math.ceil(documents.length / rowsPerPage)}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </Box>
  );
}

const DocumentTableIndex = () => {
  return (
    <div className="App">
        <AuthenticatedTemplate>
            <DocumentTable />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
            <h5 className="card-title">Please sign-in to see the documents.</h5>
        </UnauthenticatedTemplate>
    </div>
);
};

export default DocumentTableIndex;
